export default __webpack_public_path__ + "static/media/iconLogo.72a4b782.svg";